module.exports = __webpack_public_path__ + "static/img/clothing_10.1a2268e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/thumbnail/clothing_10.png
// module id = WzeK
// module chunks = 0